<template>

  <div>
      <div
        class="mb-24px"
        v-for="(filter, index) in notDropdownFilters"
        :key="index"
      >
          <FilterCheckBoxInput
              :ref="`optionsWrapper${filter.name}`"
              :class="{ [filter.class || '']: true }"
              :style="filter.styling"
              :filter="filter"
              :show-more-button="filter.showMoreButton || false"
              @selectedCheckOption="onCheckboxChange"
              @submitFilters="submitFiltersSearch"
          />

          <template v-if="filter.showMoreButton === true">
            <button
              v-if="isShowMoreBtn(filter.name)"
              class="mt-4 text-sm text-primary-darker cursor-pointer bg-transparent border-0"
              @click="toggleMoreBtnClicked(filter.name, filter.value.length)"
            >
              Show More <simple-svg src="../../../images/icons/chevron-down.svg" />
            </button>
            <button
              v-else
              class="mt-4 text-sm text-primary-darker cursor-pointer bg-transparent border-0"
              @click="toggleMoreBtnClicked(filter.name, filter.value.length)"
            >
              Show Less <simple-svg style="transform: rotate(180deg);" src="../../../images/icons/chevron-down.svg" />
            </button>
          </template>
      </div>
  </div>

</template>

<script>
import FilterInput from "./filter-input/FilterInput";
import MoreButtonMixin from "../mixins/MoreButtonMixin";
import FilterCheckBoxInput from "./filter-input/FilterCheckBoxInput";
import QueryParameters from "../utilities/queryparameters";
import queryBuilder from "../utilities/querybuilder"
import CCRequestInputMixin from "../mixins/CCRequestInputMixin";
import ScrollShadow from './ScrollShadow.vue';
import event from "../event";

export default {
  name: "AdvancedFilter",

  mixins: [
    CCRequestInputMixin,
    MoreButtonMixin
  ],

  props: {
    userFilterOptions: {},
    experiences: {
      type : Array,
      default : () => { return []}
    },
    companies: {
      type : Array,
      default : () => { return []}
    },
    locations: {
      type : Array,
      default : () => { return []}
    },
    routeTypes: {
      type : Array,
      default : () => { return []}
    },
    driverTypes: {
      type : Array,
      default : () => { return []}
    },
    licenseTypes: {
      type : Array,
      default : () => { return []}
    },
    prepopulateCity: {
      type: String,
      default: ''
    },
    urlJobs: {
      type: String,
      required: true
    },
  },

  components: {
    FilterInput, FilterCheckBoxInput, ScrollShadow
  },

  data() {
    return {
      dropdownFilter: {
        label: 'Distance',
        type: 'radio',
        value: [
          {option: "Exact location only", id: "1"},
          {option: "Within 5 miles", id: "5"},
          {option: "Within 10 miles", id: "10"},
          {option: "Within 15 miles", id: "15"},
          {option: "Within 25 miles", id: "25"},
          {option: "Within 50 miles", id: "50"},
        ],
        model: 'Radius',
        name: 'radius',
        initValue: this.userFilterOptions.radius || this.userFilterOptions[ QueryParameters.RADIUS ],
        selected: this.userFilterOptions.radius || this.userFilterOptions[ QueryParameters.RADIUS ],
        inputDisabled: this.userFilterOptions.inputDisabled.radius
      },

      notDropdownFilters: {
       /* routeType: {
          label: 'Route Type',
          name: 'routeType',
          value: [
            {option: 'All', id: '0'},
          ].concat(this.routeTypes.map(route => ({ option: `${route.name}`, id: route.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('routeType'),
          selected: this.getInitialCategoriesByType('routeType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.routeType
        },
        driverType: {
          label: 'Driver Type',
          name: 'driverType',
          value: [
            {option: 'All Driver Types', id: '0'}
          ].concat(this.driverTypes.map(driver_type => ({ option: `${driver_type.name}`, id: driver_type.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('driverType'),
          selected: this.getInitialCategoriesByType('driverType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.driverType
        },
        licenseType: {
          label: 'License Type',
          name: 'licenseType',
          value: [
            {option: 'All License Types', id: '0'}
          ].concat(this.licenseTypes.map(license => ({ option: `${license.name}`, id: license.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('licenseType'),
          selected: this.getInitialCategoriesByType('licenseType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.licenseType
        }*/
      },
      primaryLocation : this.prepopulateCity,
      jobInput: this.userFilterOptions.search_text,
    }
  },

  computed: {
    showDistanceFilter() {
      return this.userFilterOptions[ QueryParameters.RADIUS ] != '' &&
      (this.userFilterOptions[ QueryParameters.LOCATION ] != '' || this.userFilterOptions[ QueryParameters.PRIMARY_LOCATION ] != '');
    }
  },

  methods: {
    // enables not to set the same initial values on the category types filter
    getInitialCategoriesByType(arrType) {
      let firstArr = [];
      let secondArr = JSON.parse(this.userFilterOptions[ QueryParameters.CATEGORIES ] || null);

      switch (arrType){
        case 'routeType': firstArr = this.routeTypes;break;
        case 'licenseType': firstArr = this.licenseTypes;break;
        case 'driverType': firstArr = this.driverTypes;break;
      }

      if(secondArr) {
        let intersectingArr = firstArr.filter(x => secondArr.includes(`${x.id}`));

        return intersectingArr.map(x => `${x.id}`) ;
      }else {
        return [];
      }
    },

    onRadiusChange(name, value) {
      this.dropdownFilter.selected = Array.isArray(value) ? [...value] : [value];
    },

    onCheckboxChange(name, value) {
      if( Array.isArray(value) ) {
        this.notDropdownFilters[name].selected = [...value]
      }else if(name === 'location') {
        this.notDropdownFilters[name].selected = value
      }else {
        this.notDropdownFilters[name].selected = [value]
      }
    },

    submitFiltersSearch() {
      let params = {}

      // Not Dropdown Filter
      Object.keys(this.notDropdownFilters).forEach( (optKey) => {
        const opt = this.notDropdownFilters[optKey];

        if (Array.isArray(opt.selected) ) {
          if( (opt.selected.length > 0) ) {
            if (opt.type === 'radio') {
              params[opt.name] = opt.selected[0];
            }else {
              if(['routeType', 'driverType', 'licenseType'].includes(opt.name)) {
                if(Array.isArray(params[QueryParameters.CATEGORIES])) {
                  params[QueryParameters.CATEGORIES] = [...new Set([...params[QueryParameters.CATEGORIES], ...opt.selected])];
                }else {
                  params[QueryParameters.CATEGORIES] = opt.selected;
                }
              }
              else {
                params[opt.name] = opt.selected;
              }
            }
          }
        } else {
          if( opt.selected ) {
            params[opt.name] = opt.selected;
          }
        }
      });

      // Dropdown Filter
      if (Array.isArray(this.dropdownFilter.selected) ) {
        if( (this.dropdownFilter.selected.length > 0) ) {
          if (this.dropdownFilter.type === 'radio') {
            params[this.dropdownFilter.name] = this.dropdownFilter.selected[0];
          }else {
            params[this.dropdownFilter.name] = this.dropdownFilter.selected;
          }
        }
      } else {
        if( !this.dropdownFilter.selected === '0' ) {
          params[this.dropdownFilter.name] = this.dropdownFilter.selected;
        }
      }

      params.primary_location = this.primaryLocation;

      if( this.jobInput ) {
          params.search_text = this.jobInput;
      }

      let parsedParams = [];

      Object.keys(params).forEach( param => {
          switch (param){
              case 'search_text': parsedParams[ QueryParameters.KEYWORD ] = encodeURIComponent(params[ param ]);break;
              case 'primary_location': parsedParams[ QueryParameters.PRIMARY_LOCATION ] = params[ param ];break;
              case 'radius': parsedParams[ QueryParameters.RADIUS ] = params[ param ];break;
              case 'jobType': parsedParams[ QueryParameters.JOB_TYPE ] = params[ param ];break;
              case 'location': parsedParams[ QueryParameters.LOCATION ] = params[ param ];break;
              case 'category': parsedParams[ QueryParameters.CATEGORIES ] = params[ param ];break;
              case 'companies':{
                  if(params[param].length > 0 && params[param].length === this.companies.length ) {
                      parsedParams[ QueryParameters.COMPANIES ] = 'all';
                  } else {
                      parsedParams[ QueryParameters.COMPANIES ] = params[ param ];
                  }
              };break;
              case 'experience': parsedParams[ QueryParameters.EXPERIENCE ] = params[ param ];break;
              default: parsedParams[ param ] = params[param];break;
          }
      });
      // Check url for company param
      let uri = window.location.search.substring(1);
      let url_params = new URLSearchParams(uri);
      let cid = url_params.get("cid");
      let no_ip_lookup = url_params.get("no_ip_lookup");
      let kw = url_params.get("kw");
      if (cid) {
        parsedParams['cid'] = cid;
      }
      if (no_ip_lookup) {
        parsedParams['no_ip_lookup'] = no_ip_lookup;
      }
      if (kw) {
        parsedParams['kw'] = kw;
      }
      event.bus.$emit('selected-filter-data', this.routeParsed(this.urlJobs, queryBuilder.buildQueryString( parsedParams )));
    },
  }
}

</script>

<style lang="scss">
.location-scroll-container {
  transition: height 150ms ease-out;
}
</style>
